import * as React from 'react'
// components
import { Step, StepLabel, ThemeProvider } from '@mui/material'
// context
import { SubPlanStepperAPIContext } from 'containers/SubPlan/layers/API'
import { SubPlanStepperBLContext } from 'containers/SubPlan/layers/BL/Stepper'
// views
import StepIcon from 'components/Modals/CreateSubPlanModal/SubPlanStepper/components/StepIcon'
import { Stepper } from 'components/Modals/CreateSubPlanModal/SubPlanStepper/view'
// themes
import { stepperTheme } from 'themes/index'

const StepperComponent: React.FC = () => {
  const { steps } = React.useContext(SubPlanStepperAPIContext)
  const { activeStep } = React.useContext(SubPlanStepperBLContext)

  const stepConnectorStyle = {
    width: activeStep > 0 ? '20px' : '170px',
    flex: activeStep > 0 ? 'none' : 'auto',
    transition: activeStep === 1 ? '0.8s' : 'none',
    transitionDelay: '0.5s'
  }

  const theme = {
    ...stepperTheme,
    components: {
      ...stepperTheme.components,
      MuiStepConnector: {
        styleOverrides: { root: stepConnectorStyle }
      }
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, i) => {
          return (
            <Step key={i}>
              <StepLabel
                classes={{
                  labelContainer: 'stepLabel',
                  disabled: 'disabled'
                }}
                slots={{
                  stepIcon: StepIcon
                }}
                slotProps={{
                  stepIcon: { icon: i + 1 }
                }}>
                {label}
              </StepLabel>
            </Step>
          )
        })}
      </Stepper>
    </ThemeProvider>
  )
}

export default StepperComponent
